import PropTypes from 'prop-types'
import React from 'react'

import FirstBlockWrapper from 'components/_special/FirstBlockWrapper'
import ButtonScrollDown from 'components/ButtonScrollDown'
import { Text, TextSmall, H1Small as H1 } from 'styles/components/typography'

import './StoriesFirstBlock.scss'

const StoriesFirstBlock = ({
  description,
  title,
  subtitle,
  scroll_to_site,
  secondBlockRef,
}) => {
  return (
    <FirstBlockWrapper className="stories-first-block pb-2 pb-md-4 ">
      <div className="row" />
      <div className="row">
        <div className="col-12 col-md-6 text-white pt-md-4">
          <Text dangerouslySetInnerHTML={{ __html: description }} />
          <H1 dangerouslySetInnerHTML={{ __html: title }} className="mb-0" />
          <TextSmall dangerouslySetInnerHTML={{ __html: subtitle }} />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <ButtonScrollDown
            title={scroll_to_site}
            isLightColor={true}
            refToScroll={secondBlockRef}
          />
        </div>
      </div>
    </FirstBlockWrapper>
  )
}

StoriesFirstBlock.propTypes = {
  secondBlockRef: PropTypes.object.isRequired,
  scroll_to_site: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

export default StoriesFirstBlock
